import { NgModule } from '@angular/core';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import { FormsModule } from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import {ToastModule} from 'primeng/toast';
import { AuthModule } from '../auth.module';
import { PageLoginPopupsModule } from '../../tools/page-login-popups/page-login-popups.module';
import { DividerModule } from 'primeng/divider';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { OutsideClickDirective } from 'src/app/directives/outside-click';
import { StepsModule } from 'primeng/steps';
import { MessagesModule } from 'primeng/messages';
import { SelfFocusDirective } from 'src/app/directives/self-focus';
import {ConfirmDialogModule} from "primeng/confirmdialog";

@NgModule({
    declarations: [
        LoginComponent,
        OutsideClickDirective,
        SelfFocusDirective
    ],
    exports: [
        LoginComponent
    ],
  imports: [
    LoginRoutingModule,
    InputTextModule,
    PasswordModule,
    AppConfigModule,
    FormsModule,
    DialogModule,
    ToastModule,
    AuthModule,
    PageLoginPopupsModule,
    DividerModule,
    ConfirmPopupModule,
    ProgressSpinnerModule,
    DropdownModule,
    StepsModule,
    MessagesModule,
    ConfirmDialogModule
  ],
    providers: [
        ConfirmationService
    ]
})
export class LoginModule { }
